var BraintreeCardPersistPaymentProvider = (function (BraintreeCardAbstract, CheckoutSettings) {

    var BraintreeCardPersistPaymentProvider = BraintreeCardAbstract.extend({

        paymentOption: CheckoutSettings.PaymentOption.OurPay,
        _supportedTypes: braintreeSupportedTypes.card.concat(['OurpaySelect']),

        complete: function (method) {
            var transactionData = {
                paymentType: 'mypay',
                provider: 'braintree',
                selectedPaymentOption: this.paymentOption,
                paymentNonce: method.Nonce || '',
                deviceData: this.braintree.kount.getDeviceData() || ''
            };

            return this._createPaymentTransaction(transactionData, { wait: true, preventDoubleRequests: true, hideErrors: this.hideErrors });
		}
	});

	return BraintreeCardPersistPaymentProvider;
})(BraintreeCardAbstract, CheckoutSettings);